import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown, FaTimes } from 'react-icons/fa';

const MultiSelectDropdown = ({ options, selected = [], onChange, placeholder = "Select...", name }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleOption = (option) => {
        let newSelected; // Array
        // Ensure selected is an array
        const currentSelected = Array.isArray(selected) ? selected : (selected ? [selected] : []);

        if (currentSelected.includes(option)) {
            newSelected = currentSelected.filter(item => item !== option);
        } else {
            newSelected = [...currentSelected, option];
        }

        onChange({ target: { name, value: newSelected } });
    };

    const filteredOptions = options.filter(opt =>
        opt.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="position-relative" ref={dropdownRef}>
            <div
                className="form-input d-flex justify-content-between align-items-center bg-white"
                onClick={() => setIsOpen(!isOpen)}
                style={{ cursor: 'pointer', minHeight: '38px', backgroundColor: '#fff' }}
            >
                <div className="text-truncate" style={{ maxWidth: '90%' }}>
                    {Array.isArray(selected) && selected.length > 0
                        ? `${selected.length} Selected`
                        : <span className="text-muted">{placeholder}</span>
                    }
                </div>
                <FaChevronDown className="text-muted" size={12} />
            </div>

            {isOpen && (
                <div className="position-absolute w-100 bg-white border rounded shadow-sm mt-1" style={{ zIndex: 1050, maxHeight: '250px', overflowY: 'auto' }}>
                    <div className="p-2 sticky-top bg-white border-bottom">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                        />
                    </div>
                    <div className="p-1">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option, index) => (
                                <div key={index} className="d-flex align-items-center p-2 hover-bg-light rounded" style={{ cursor: 'pointer' }} onClick={() => toggleOption(option)}>
                                    <input
                                        className="form-check-input m-0 me-2 shadow-none"
                                        type="checkbox"
                                        id={`${name}-${index}`}
                                        checked={Array.isArray(selected) && selected.includes(option)}
                                        onChange={() => { }} // Handled by parent div click
                                        style={{ pointerEvents: 'none' }} // Let parent div handle click
                                    />
                                    <label className="w-100 user-select-none" style={{ cursor: 'pointer', pointerEvents: 'none', marginBottom: 0 }}>
                                        {option}
                                    </label>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-muted small p-2">No options found</div>
                        )}
                    </div>
                </div>
            )}

            {(Array.isArray(selected) && selected.length > 0) && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                    {selected.map((item, idx) => (
                        <span key={idx} className="badge bg-light text-dark border p-2 d-flex align-items-center fw-normal">
                            {item}
                            <FaTimes
                                className="ms-2 text-muted hover-text-danger"
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleOption(item);
                                }}
                            />
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelectDropdown;
